import { Typography } from "@material-ui/core"

const Costs = (props) => {

  return ( <>
    <Typography>
      The base price for a custom song is just $99—way cheaper than hiring a full band to follow you around serenading your life. Want to add a little extra flair? You can get a custom lyric card with your photo for $20, upload your song to Spotify or Amazon Music for $15, or speed up the process with expedited delivery for $25. No hidden fees, no surprise costs—just a killer song made just for you!
    </Typography>
  </> )
}

export default Costs
